import IdentifyBanking from "./identifyBanking";
export default IdentifyBanking;